<template>
	<div v-if="item">
		<div class="alert alert-info" v-if="item.ticketGroups.length <= 0">
			<div>
				<h5>Crea tus tickets para poder comezar a vender entradas.</h5>
			</div>

			<router-link tag="a" :to="`/events/${item.id}/ticketGroups/create`" class="btn btn-primary">
				Crear grupo de tickets
			</router-link>
		</div>

		<div class="row row-xs">
			<div class="col col-md-4">
				<div class="card">
					<div class="card-body p-3">
						<h5>Resultados del evento</h5>
						Ventas, ventas netas, visitas, tasa de conversiaon, etc...
					</div>
				</div>
			</div>
			<div class="col col-md-8">
				<div class="row row-xs">
					<div class="col col-md-6">
						<div class="box">
							<div class="ico">
								<i class="icon icon-ticket-big"></i>
							</div>
							<div class="info">
								<h3>Entradas vendidas</h3>
								<p>{{ item.ticketsSold }} de {{ item.ticketsLimit }}</p>
							</div>
							<div>
								<vc-donut
									foreground="#f3f3f3"
									:size="60"
									unit="px"
									:thickness="22"
									:sections="[{ value: item.ticketsSoldPercent }]"
									:total="100"
									:start-angle="0"
									:auto-adjust-text-size="true"
								>
									<div style="font-size:15px">{{ item.ticketsSoldPercent }}%</div>
								</vc-donut>
							</div>
						</div>
					</div>

					<div class="col col-md-6">
						<div class="box">
							<div class="ico"><i class="icon icon-dollar"></i></div>
							<div class="info"><h3>Ventas</h3></div>
							<div>
								<h4>{{ item.currencySymbol }} {{ item.totalSales }}</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="row row-xs">
					<div class="col-12 mt-3">
						<EventTicketGroups
							ref="eventTicketGroup"
							:eventId="item.id"
							:canCreate="false"
							:collapsed="true"
							@updated="load"
						/>
					</div>

					<div class="col-12 mt-3">
						<h5>Compartir link del evento</h5>

						<ShareLink :link="item.publicLink" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import gql from "graphql-tag"
import EventTicketGroups from "./EventTicketGroups"
import ShareLink from "@/components/ShareLink"

export default {
	name: "EventDashboard",
	components: {
		EventTicketGroups,
		ShareLink
	},
	props: {
		eventId: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			item: null,
			loading: false
		}
	},
	async beforeMount() {
		this.loading = true
		this.item = await this.load()
		this.loading = false
	},
	methods: {
		async load() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							event(id: $id) {
								id
								name
								startAt
								endAt
								description
								image {
									id
									type
									filename
									url
									urlThumb
								}
								location {
									id
									name
									locality {
										name
										region {
											name
										}
									}
									address
									latlng {
										lat
										lng
									}
								}
								ticketGroups {
									id
									name
									ticketsLimit
									minPerOrder
									maxPerOrder
									validAt
									ticketTypes {
										id
										name
										ticketsLimit
										priceUnit
									}
								}
								ticketsLimit
								ticketsSold
								ticketsSoldPercent
								totalSales
								currencySymbol
								publicLink
								status
								statusText
								statusClass
							}
						}
					`,
					variables: { id: this.eventId },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					return data.event
				})
				.catch(() => {})
		}
	}
}
</script>

<style scoped lang="scss"></style>
